import React from "react";

function pageWindow(page, pages, size = 7) {
  if (pages <= size) return Array.from({ length: pages }, (_, i) => i + 1);
  let start = Math.max(1, page - Math.floor(size / 2));
  let end = start + size - 1;
  if (end > pages) { end = pages; start = Math.max(1, end - size + 1); }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

export function Pagination({ page, pages, onPage, total, shown, label = "registros" }) {
  if (!pages || pages <= 1) {
    if (total != null) {
      return (
        <p className="text-center text-xs text-gray-400 mt-3 font-medium">
          {shown != null ? `${shown} de ${total}` : total} {label}
        </p>
      );
    }
    return null;
  }

  const nums = pageWindow(page, pages);

  return (
    <div className="mt-5 flex flex-col items-center gap-2">
      <div className="flex items-center gap-1.5">
        {/* Prev */}
        <button
          onClick={() => onPage(page - 1)}
          disabled={page === 1}
          className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-[#151C84] hover:border-[#151C84]/30 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        {/* First page + ellipsis if needed */}
        {nums[0] > 1 && (
          <>
            <button onClick={() => onPage(1)} className="w-9 h-9 rounded-xl font-semibold text-sm text-gray-600 hover:bg-gray-100 hover:text-[#151C84] transition-all">1</button>
            {nums[0] > 2 && <span className="w-9 h-9 flex items-center justify-center text-gray-400 text-sm">…</span>}
          </>
        )}

        {/* Window */}
        {nums.map((n) => (
          <button
            key={n}
            onClick={() => onPage(n)}
            className={`w-9 h-9 rounded-xl font-semibold text-sm transition-all ${
              page === n
                ? "bg-[#151C84] text-white shadow-[0_4px_12px_rgba(21,28,132,0.3)]"
                : "text-gray-600 hover:bg-gray-100 hover:text-[#151C84]"
            }`}
          >
            {n}
          </button>
        ))}

        {/* Last page + ellipsis if needed */}
        {nums[nums.length - 1] < pages && (
          <>
            {nums[nums.length - 1] < pages - 1 && <span className="w-9 h-9 flex items-center justify-center text-gray-400 text-sm">…</span>}
            <button onClick={() => onPage(pages)} className="w-9 h-9 rounded-xl font-semibold text-sm text-gray-600 hover:bg-gray-100 hover:text-[#151C84] transition-all">{pages}</button>
          </>
        )}

        {/* Next */}
        <button
          onClick={() => onPage(page + 1)}
          disabled={page === pages}
          className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-[#151C84] hover:border-[#151C84]/30 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {total != null && (
        <p className="text-xs text-gray-400 font-medium">
          {shown != null ? `${shown} de ${total}` : total} {label}
        </p>
      )}
    </div>
  );
}
